export default "__VITE_ASSET__CqzZjthf__"